import React from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import { SearchTrigger } from '@atlassian/csm-widget-ui-components/search-trigger';
import { messages } from './messages';
export var AiPreview = function AiPreview() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(SearchTrigger, {
    placeholder: formatMessage(messages.searchPreviewText),
    submitButton: /*#__PURE__*/React.createElement(IconButton, {
      shape: "circle",
      icon: ArrowRightIcon,
      isDisabled: true,
      label: ""
    })
  });
};